<div class="px-4 py-4">
  <p class="mb-3 text-xs font-semibold uppercase tracking-wide text-gray-400">
    Commission Line Items
  </p>
  <div class="overflow-x-auto rounded-md border border-gray-200">
    <table class="min-w-full divide-y divide-gray-200 text-sm">
      <thead class="bg-slate-600 text-slate-100">
        <tr>
          <th class="p-3 text-left">Referral Code</th>
          <th class="p-3 text-left">Commission Type</th>
          <th class="p-3 text-left">Description</th>
          <th class="p-3 text-right">Amount</th>
        </tr>
      </thead>
      <tbody class="divide-y divide-gray-200">
        @for (item of lineItems(); track item.commission_id) {
        <tr class="hover:bg-gray-50">
          <td class="p-3 font-mono">
            <a
              [routerLink]="['/referrals', item.referral_id]"
              class="font-medium text-orange-600 hover:text-orange-700 underline"
              >{{ item.referral_code }}</a
            >
          </td>
          <td class="p-3">{{ typeLabel(item.commission_type) }}</td>
          <td class="p-3 text-gray-600">{{ item.description || '–' }}</td>
          <td class="p-3 text-right font-semibold">
            {{ formatMoney(item.amount_minor, item.currency) }}
          </td>
        </tr>
        } @empty {
        <tr>
          <td colspan="4" class="p-4 text-center text-sm text-gray-500">
            No line items
          </td>
        </tr>
        } @if (lineItems().length > 1) {
        <tr class="bg-gray-50 font-medium">
          <td colspan="3" class="p-3">Total</td>
          <td class="p-3 text-right">
            {{ formatMoney(lineItemTotal(), currency()) }}
          </td>
        </tr>
        }
      </tbody>
    </table>
  </div>
</div>
